// extracted by mini-css-extract-plugin
export default {"mainLayout":"Terms_mainLayout__Yb4l5","left":"Terms_left__j11mJ","procedure":"Terms_procedure__nWGr4"};